import React from "react";
import { NavLink } from "react-router-dom";
import { useSeo } from "../../seo/useSeo";
import "./404.css";

const FourZeroFour = () => {
  useSeo({
    title: "Pagina nu a fost găsită | Travel Time",
    description: "Pagina căutată nu există sau a fost mutată.",
    path: null,
    noindex: true,
  });

  return (
    <>
      <div id="notfound">
        <div className="notfound">
          <div className="notfound-404">
            <h1>404</h1>
          </div>
          <h2>We are sorry , page not found</h2>
          <p>
            The page you are looking for might have been removed, had it's name
            change or is temporarily unavailable.{" "}
          </p>
          <NavLink to="/"> Back to Homepage</NavLink>
        </div>
      </div>
    </>
  );
};

export default FourZeroFour;
